import { dew as _sliceDew } from "../data/slice.js";
import { dew as _toBytesDew } from "../encoding/toBytes.js";
import { dew as _getFunctionSignatureDew } from "./getFunctionSignature.js";
import { dew as _keccakDew } from "./keccak256.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getFunctionSelector = void 0;
  const slice_js_1 = _sliceDew();
  const toBytes_js_1 = _toBytesDew();
  const getFunctionSignature_js_1 = _getFunctionSignatureDew();
  const keccak256_js_1 = _keccakDew();
  const hash = value => (0, keccak256_js_1.keccak256)((0, toBytes_js_1.toBytes)(value));
  const getFunctionSelector = fn => (0, slice_js_1.slice)(hash((0, getFunctionSignature_js_1.getFunctionSignature)(fn)), 0, 4);
  exports.getFunctionSelector = getFunctionSelector;
  //# sourceMappingURL=getFunctionSelector.js.map
  return exports;
}